<template>
  <div>
    <choice-vote-content :items="items" />
    <div class="mt-3" v-if="items.length >  5">
      <el-button class="w-full" @click="onShowMoreRank">查看更多排名</el-button>
    </div>
  </div>
</template>

<script>
import { questionType } from 'dygc'
import ChoiceVoteContent from '@/vote/ChoiceVoteContent.vue'
import { createPopup } from '@/assets/js/factory'
import ChoiceMoreRank from '@/vote/ChoiceMoreRank.vue'

export default {
  name: 'Cascade',
  components: { ChoiceVoteContent },
  type: [questionType.LINKAGE],
  props: {
    question: {
      type: Object
    }
  },
  computed: {
    items() {
      return this.getVoteItems()
    }
  },
  methods: {
    onShowMoreRank() {
      createPopup(ChoiceMoreRank, {
        question: this.question,
        items: this.items
      })
    },
    getVoteItems() {
      const results = this.getAllVoteItems(this.question.vote)
      const ids = this.question.issue.voteAnswer
      if (!ids.length) return results
      return results.filter(item => {
        const lastId = item.id.split('/').pop()
        return ids.includes(lastId)
      })
    },
    getAllVoteItems(vote) {
      const items = this.question.issue.toOneArray()
      return items.map(item => {
        const id = item.id.split('/').pop()
        item.content = { richText: item.text }
        const voteNum = vote.oidCountMap[id] || 0
        let percentage = vote.totalNum ? Number((voteNum / vote.totalNum * 100).toFixed(0)) : 0
        return Object.assign({}, item, { percentage, voteNum })
      })
          .sort((a, b) => b.voteNum - a.voteNum)
          .map((item, index) => {
            return Object.assign({}, item, { num: index + 1 })
          })
    },
  }
}
</script>

<style scoped>

</style>